export enum MixpanelItems {
    Login = "Login",
    SessionStart = "Session start",
    SessionEnd = "LoginSession end",
    SelectedNiche = "Selected niche",
    SelectedFirstFilter = "Selected first filter",
    FiltrationResponse = "Filtration response",
    EnterUploadFilePage = "Enter UploadFile Page",
    EnterGeneralAudiencePage = "Enter General Audience Page",
    EnterCustomAudiencePage = "Enter Custom Audience Page",
    EnterExportPage = "Enter Export Page",
    EnterResendEmailPage = "Enter Resend Email Page",
    UploadedCSVFileSuccessfully = "Uploaded CSV file successfully",
    UploadedCSVFileFailed = "Uploaded CSV file failed",
    ExportError = "Export error",
    ExportSuccess = "Export success",
    ResendEmail = "Resend email",
    ResendToAnotherEmail = "Resend to another email",
    AddSocialMedia = "Add social media",
    RemoveSocialMedia = "Remove social media",
    AddValidTwitterId = "Enter valid Twitter ID",
    ClickSupport = "Click support Button",
    ClickSupportFromFile = "Click support Button from failed file download",
    DownloadSampleCSV = "Download sample CSV",
}